import OverlayImageWrapper from './style/overlayImageWrapper';

const OverlayImage = ({
  image,
  opacity,
  overlayText,
  alt,
  imageClassName,
  containerClassName,
  textContainerClassName,
}) => (
  <OverlayImageWrapper opacity={opacity} className={containerClassName || ''}>
    <img src={image} className={imageClassName || ''} alt={alt} />
    <div className={`overlay ${textContainerClassName || ''}`}>{overlayText}</div>
  </OverlayImageWrapper>
);

export default OverlayImage;
